module.exports = __webpack_public_path__ + "static/media/mastercard.fefd8034.png";